module.exports = __webpack_public_path__ + "img/ios-app-store.45f62c46.svg";